import { Model } from "./model";

export class Country extends Model {
	private iso: string = "";
	private name: string = "";
	private i18n_name: string = "";
	private phonecode: number = 0;
	private usable: boolean = false;
	private e_money: boolean = false;
	private ssn_required: boolean = false;

	public getIso(): string {
		return this.iso;
	}

	public getName(): string {
		return this.name;
	}

	public getI18Nname(): string {
		return this.i18n_name;
	}

	public getPhoneCode(): number {
		return this.phonecode;
	}

	public isUsable(): boolean {
		return this.usable;
	}

	public isEMoney(): boolean {
		return this.e_money;
	}

	public getSsnRequired(): boolean {
		return this.ssn_required;
	}
}
